"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.willReviewFlagExpenseAsGobdCompliantInvoice = exports.willUpdateFlagExpenseAsGobdCompliantInvoice = exports.canExpenseBeFlaggedAsGobdCompliantInvoice = exports.diagnoseExpenseForGobdCompliance = exports.isExpenseGobdInvoiceCompliant = void 0;
const moment_1 = __importDefault(require("moment"));
const models_1 = require("../models");
const common_1 = require("./common");
const datevValidation_1 = require("./datevValidation");
const expense_utils_1 = require("./expense.utils");
const isExpenseGobdInvoiceCompliant = (expense, considerInternalRequirements = false) => {
    const { requirements, internalRequirements, cpuDateIsValid } = (0, exports.diagnoseExpenseForGobdCompliance)(expense);
    const areExpenseRequirementsFulfilled = Object.values(requirements).every((v) => v);
    const areInternalRequirementsFulfilled = Object.values(internalRequirements).every((v) => v);
    // Will not mark this as a GoB compliant invoice, if the CPU date is going to be invalid.
    // The criteria is that the CPU Date MUST be equal or before the Accounting Period / Booking Date.
    return areExpenseRequirementsFulfilled && (!considerInternalRequirements || areInternalRequirementsFulfilled) && cpuDateIsValid;
};
exports.isExpenseGobdInvoiceCompliant = isExpenseGobdInvoiceCompliant;
const diagnoseExpenseForGobdCompliance = (expense) => {
    const requirements = {
        status: isExpenseStatusReadyForGobdCompliantInvoice(expense),
        amounts: isAmountGobdInvoiceCompliant(expense),
        vat: isVatGobdInvoiceCompliant(expense),
        vendor: isVendorGobdInvoiceCompliant(expense),
        buCode: isBuCodeGobdInvoiceCompliant(expense),
        invoiceDate: isInvoiceDateGobdInvoiceCompliant(expense),
        invoiceNumber: isInvoiceNumberCompliant(expense),
        bookingText: isBookingTextCompliant(expense),
        expenseAccount: isExpenseAccountCompliant(expense),
        accountingPeriod: isAccountingPeriodCompliant(expense), // To be set by machine on last approval (when entering "To be reviewed" state). If expense is not a Beleg yet when it's set, its editable
    };
    // These properties are generated backend side, user cannot do anything about it.
    const internalRequirements = {
        cpuDate: isCpuDateCompliant(expense),
    };
    const cpuDateIsValid = !!expense.gobdInvoiceComplianceDate || (expense.accountingPeriod && (0, moment_1.default)().isSameOrBefore(expense.accountingPeriod, "day"));
    return {
        requirements,
        internalRequirements,
        cpuDateIsValid,
    };
};
exports.diagnoseExpenseForGobdCompliance = diagnoseExpenseForGobdCompliance;
const canExpenseBeFlaggedAsGobdCompliantInvoice = (expense) => (0, exports.isExpenseGobdInvoiceCompliant)(expense);
exports.canExpenseBeFlaggedAsGobdCompliantInvoice = canExpenseBeFlaggedAsGobdCompliantInvoice;
const isExpenseStatusReadyForGobdCompliantInvoice = (expense) => [models_1.ExpenseStatusEnum.REVIEWED, models_1.ExpenseStatusEnum.PAID, models_1.ExpenseStatusEnum.DONE].includes(expense.status);
const isAmountGobdInvoiceCompliant = (expense) => {
    const amountsToCheck = [expense.totalGrossPrice, expense.totalNetPrice, expense.totalTaxPrice];
    for (const split of expense.splits) {
        amountsToCheck.push(split.netPrice, split.taxPrice, split.grossPrice);
    }
    if (!amountsToCheck.every((amount) => (0, common_1.isNumeric)(amount)))
        return false;
    return (0, datevValidation_1.isConsolidatedAmountSafe)(expense);
};
const isVatGobdInvoiceCompliant = (expense) => expense.splits.every((s) => { var _a, _b; return !isNaN((_b = (_a = s.taxRate) === null || _a === void 0 ? void 0 : _a.taxRate) !== null && _b !== void 0 ? _b : NaN); });
const isBuCodeGobdInvoiceCompliant = (expense) => expense.splits.length > 0 && expense.splits.every((s) => { var _a; return !!((_a = s.taxRate) === null || _a === void 0 ? void 0 : _a.buCode); });
const isInvoiceDateGobdInvoiceCompliant = (expense) => expense.invoiceDate && (0, moment_1.default)(expense.invoiceDate).isValid();
const isInvoiceNumberCompliant = (expense) => expense.invoiceNumber && typeof expense.invoiceNumber === "string" && expense.invoiceNumber.length > 0;
const isVendorGobdInvoiceCompliant = (expense) => (0, expense_utils_1.isExpenseVendorDefined)(expense);
const isBookingTextCompliant = (expense) => expense.description && typeof expense.description === "string" && expense.description.length > 0;
const isExpenseAccountCompliant = (expense) => expense.splits.length > 0 && expense.splits.every((s) => { var _a; return (_a = s.expenseAccount) === null || _a === void 0 ? void 0 : _a.accountCode; });
const isAccountingPeriodCompliant = (expense) => expense.accountingPeriod && (0, moment_1.default)(expense.accountingPeriod).isValid();
const isCpuDateCompliant = (expense) => expense.gobdInvoiceComplianceDate && (0, moment_1.default)(expense.gobdInvoiceComplianceDate).isValid();
const willUpdateFlagExpenseAsGobdCompliantInvoice = (oldExpenseState, newExpenseState) => !oldExpenseState.gobdInvoiceComplianceDate && (0, exports.canExpenseBeFlaggedAsGobdCompliantInvoice)(newExpenseState);
exports.willUpdateFlagExpenseAsGobdCompliantInvoice = willUpdateFlagExpenseAsGobdCompliantInvoice;
const willReviewFlagExpenseAsGobdCompliantInvoice = (expense) => {
    const expenseToTest = new models_1.Expense(Object.assign(Object.assign({}, expense), { status: models_1.ExpenseStatusEnum.REVIEWED }));
    return (0, exports.willUpdateFlagExpenseAsGobdCompliantInvoice)(expense, expenseToTest);
};
exports.willReviewFlagExpenseAsGobdCompliantInvoice = willReviewFlagExpenseAsGobdCompliantInvoice;
